import { FlowItem, FlowParameterRunItem, IIdItem } from '../../../spacesPlatform/models/resourceParts';

export type FlowRun = FlowItem & IIdItem & FlowParameterRunItem & {
  readonly startedAt: string; // YYYY-MM-DDThh:mm:ssZ
  readonly completedAt: string; // YYYY-MM-DDThh:mm:ssZ
  readonly status: string; // [ PENDING, INPROGRESS, SUCCESS, FAILED, CANCELLED ]
  readonly taskId: string;
  readonly triggerType: FlowRunTriggerType;
  readonly errorMessage: string;
  readonly outputStepIds: ReadonlyArray<string>;
  readonly outputStepRunIds: ReadonlyArray<string>;
  // The background job that executed this flow run. A flow run id and its background job id are
  // distinct id-spaces; cancellation targets the background job, so it is surfaced here for the
  // client to pass to cancelBackgroundJob.
  readonly backgroundJobId?: string;
};

export enum FlowRunTriggerType {
  adhoc = 'AdHoc',
  scheduled = 'Scheduled',
}
